<div class="dialog-header">
    <h2 mat-dialog-title>Merge Preview</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    @let preview = preview$ | async;
    @let isLoading = isLoading$ | async;
    @let source = sourceDataset$ | async;
    @let target = targetDataset$ | async;

    @if (isLoading) {
        <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
        </div>
    }

    @if (preview) {
        <p class="dataset-info">
            <span class="dataset-label">{{ source }}</span>
            <mat-icon>arrow_forward</mat-icon>
            <span class="dataset-label">{{ target }}</span>
        </p>

        <!-- Fund -->
        <div class="merge-section">
            <div class="section-header">
                <h3>Fund</h3>
                <button mat-stroked-button (click)="autoMatchAssets()" [disabled]="isAutoMatching" class="auto-match-button">
                    @if (isAutoMatching) {
                        <mat-spinner diameter="16"></mat-spinner>
                    }
                    Auto-match
                </button>
            </div>
            <div class="merge-row">
                <span class="source-name">{{ preview.fund?.sourceName }}</span>
                <mat-icon>arrow_forward</mat-icon>
                @if (preview.fund?.action === 'MERGE') {
                    <span class="target-name">{{ preview.fund?.targetName }}</span>
                } @else {
                    <span class="create-new">Create new</span>
                }
                <button mat-icon-button (click)="openFundSearch()">
                    <mat-icon>search</mat-icon>
                </button>
                @if (preview.fund?.action === 'MERGE') {
                    <button mat-icon-button (click)="clearFundMergeTarget()">
                        <mat-icon>delete</mat-icon>
                    </button>
                }
            </div>
        </div>

        <!-- Fund Reports -->
        <div class="merge-section">
            <h3>Fund Report</h3>
            @for (report of preview.reports; track report.sourceId) {
                <div class="merge-row">
                    <span class="source-name">{{ report.sourceReportDate }}</span>
                    <mat-icon>arrow_forward</mat-icon>
                    @if (report.action === 'MERGE') {
                        <span class="target-name">{{ report.targetReportDate }}</span>
                    } @else {
                        <span class="create-new">Create new</span>
                    }
                </div>
            }
        </div>

        <!-- Assets -->
        <div class="merge-section">
            <h3>Assets ({{ preview.assets?.length ?? 0 }})
                <mat-icon class="info-icon" matTooltip="Country code shown in parentheses for identification">info_outline</mat-icon>
            </h3>
            <table class="assets-table">
                <tbody>
                    @for (asset of preview.assets; track asset.sourceId) {
                        <tr>
                            <td class="source-name">
                                {{ asset.sourceName }}
                                @if (asset.sourceCountry) { ({{ asset.sourceCountry }}) }
                            </td>
                            <td class="arrow-cell">
                                <mat-icon>arrow_forward</mat-icon>
                            </td>
                            <td class="target-cell">
                                @if (asset.action === 'MERGE') {
                                    <span class="target-name">
                                        {{ asset.targetName }}
                                        @if (asset.targetCountry) { ({{ asset.targetCountry }}) }
                                    </span>
                                } @else if (asset.matchCount !== undefined && asset.matchCount !== null) {
                                    @if (asset.matchCount === 0) {
                                        <span class="no-match">Not found</span>
                                    } @else {
                                        <span class="multiple-match">{{ asset.matchCount }} found</span>
                                    }
                                } @else {
                                    <span class="create-new">Create new</span>
                                }
                            </td>
                            <td class="actions-cell">
                                <button mat-icon-button (click)="openAssetSearch(asset)">
                                    <mat-icon>search</mat-icon>
                                </button>
                                @if (asset.action === 'MERGE') {
                                    <button mat-icon-button (click)="clearAssetMergeTarget(asset)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }

    @if (targetChangeError) {
        <valumize-info-panel
            [appearance]="'ERROR'"
            [message]="targetChangeError">
        </valumize-info-panel>
    }
</mat-dialog-content>
